"use client";

import { FC } from "react";
import Image from "next/image";
import Link from "next/link";
import { FragmentOf } from "gql.tada";
import { ArrowRight } from "lucide-react";
import { collectionFragment } from "@/graphql/queries/collections";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
interface CollectionCardProps {
  collection: FragmentOf<typeof collectionFragment>;
}
export const CollectionCard: FC<CollectionCardProps> = ({
  collection
}) => {
  return <div className="group" data-sentry-component="CollectionCard" data-sentry-source-file="CollectionCard.tsx">
      <Link href={`/shop?f_category=${collection.slug}`} data-sentry-element="Link" data-sentry-source-file="CollectionCard.tsx">
        <Card className="relative aspect-square overflow-hidden" data-sentry-element="Card" data-sentry-source-file="CollectionCard.tsx">
          {collection.featuredAsset && <Image fill priority alt={collection.featuredAsset?.name} className="absolute inset-0 z-0 object-cover transition-transform duration-500 md:group-hover:scale-105" src={collection.featuredAsset?.preview} />}
          <div className="absolute inset-0 z-10 flex flex-col justify-end bg-gradient-to-t from-primary/90 to-transparent to-60% p-6">
            <div className="translate-y-[50%] transform transition-all duration-300 md:group-hover:translate-y-0">
              <h2 className="mb-2 text-2xl font-semibold text-white lg:text-3xl">
                {collection.name}
              </h2>
              <Button className="mt-2 hidden transition-opacity duration-300 md:flex md:opacity-0 md:group-hover:opacity-100" variant="secondary" data-sentry-element="Button" data-sentry-source-file="CollectionCard.tsx">
                Shop Now <ArrowRight className="ml-2 h-4 w-4" data-sentry-element="ArrowRight" data-sentry-source-file="CollectionCard.tsx" />
              </Button>
            </div>
          </div>
        </Card>
      </Link>
    </div>;
};